import { useState, useEffect, useCallback } from "react";

export const persistentInputTypes = {
  WORKFLOW_STEP_USER_RESPONSE: "workflow_step_user_response",
} as const;

type ResourceType =
  (typeof persistentInputTypes)[keyof typeof persistentInputTypes];

export const usePersistentInput = (
  resourceType: ResourceType,
  resourceId: number,
  defaultValue = "",
): [string, (value: string) => void, () => void] => {
  const [value, setValue] = useState(() => {
    return (
      localStorage.getItem(`${resourceType}:${resourceId}`) ?? defaultValue
    );
  });

  const clearPersistedInput = useCallback(() => {
    localStorage.removeItem(`${resourceType}:${resourceId}`);
    setValue(defaultValue);
  }, [resourceType, resourceId, defaultValue]);

  useEffect(() => {
    if (value === defaultValue) {
      localStorage.removeItem(`${resourceType}:${resourceId}`);
      return;
    } else {
      localStorage.setItem(`${resourceType}:${resourceId}`, value);
    }
  }, [value, resourceType, resourceId, defaultValue]);

  return [value, setValue, clearPersistedInput];
};
